import { render, staticRenderFns } from "./Registro_consumo.vue?vue&type=template&id=4cf1aed8"
import script from "./Registro_consumo.vue?vue&type=script&lang=js"
export * from "./Registro_consumo.vue?vue&type=script&lang=js"
import style0 from "./Registro_consumo.vue?vue&type=style&index=0&id=4cf1aed8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports